module.exports = __webpack_public_path__ + "static/img/lb4.832b4a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lb4.jpg
// module id = u42A
// module chunks = 0